export function checkGraphQLConflict(errors: any[]) {
    return errors?.some((error: any) => {
        const msg = error?.message?.toLocaleLowerCase();

        return !!msg?.includes('uniqueness');
    });
}
